<template>
  <span>
    <div class="">
      <div>
        <h5 class="bold mb-2">API Keys</h5>

        <span v-for="data in ApiKeys" :key="data">
          <form class="row px-0 mx-0">
            <div class="col-6 mb-4">
              <div class="form-group">
                <label for="firstName" class="mb-2 d-block">{{
                  data.attributes.name
                }}</label>
                <input
                  type="text"
                  v-model="apiObject[data.attributes.name]"
                  class="form-control"
                />
              </div>
            </div>
          </form>
          <button
            @click.prevent="updateKeyValue(data, apiObject[data.attributes.name])"
            class="btn btn-primary btn-lg btn-round"
          >
            Actualizar Key - {{ data.attributes.name }}
          </button>
        </span>
      </div>
    </div>
  </span>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ApiKeys: [],
      apiObject: {},
    };
  },
  mounted() {
    this.getApiKeys();
  },
  methods: {
    updateKeyValue(data, value) {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/ApiKey/updatekey/" + data.attributes.name;
      axios
        .post(url, {
          name: data.attributes.name,
          key: value,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al Actualizar");
          this.is_loading = false;
          return;
        });
    },
    getApiKeys() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/ApiKey/listAll";

      // eslint-disable-next-line no-unreachable
      axios
        .get(url)
        .then((response) => {
          this.ApiKeys = response.data.body;
          this.ApiKeys.forEach((element) => {
            this.$set(this.apiObject, element.attributes.name, element.attributes.key);
          });

          this.is_loading = false;
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// CredencialesView.vue?5b8c3ba3